import img1 from "../../images/fruits/licensed-image.jpg";
import img2 from "../../images/fruits/226_119_popup.jpg";
import img3 from "../../images/fruits/560-100-natural-sweet-fresh-valencia-orange-from-egypt-2.jpg";
import img4 from "../../images/fruits/l-intro-1648153419.jpg";
import img5 from "../../images/fruits/download (2).jpg";

const product_card = [
  {
    id: 1,
    product_name: "Royal Gala Fresh Apples",
    description:
      "Actual product packaging and materials may contain more and different information than what is shown on our app or website.",
    thumb: img1,
  },
  {
    id: 2,
    product_name: "Valencia Oranges",
    description:
      "The Valencia orange is a sweet orange cultivar named after the famed oranges in València, Spain.",
    thumb: img2,
  },
  {
    id: 3,
    product_name: "Egypt Valencia Orange",
    description:
      "This Valencia Orange is a new arrival from Egypt. It is a large variety of orange with a pebbled and smooth surface with a thick fragrant peel that loosely clings to its segmented seeded flesh. When ripe, its flesh is remarkably juicy, sweet, and tender. ",
    thumb: img3,
  },
  {
    id: 4,
    product_name: "Fresh Apples",
    description:
      "What's better than munching Organic Honeycrisp apples  for a snack? Not much!  Honeycrisp apples are know for being great eating apples--of course if you decide to make a pie they will work for that too!",
    thumb: img4,
  },
  {
    id: 5,
    product_name: "Florida Citrus",
    description:
      "the Sunshine State has led the way in production of oranges and other citrus fruits. Much of the state’s success can be attributed not only to the ideal weather conditions, but to the dedication and quality of its producers.",
    thumb: img5,
  },
];

export default product_card;
